import React, { useState } from "react";
import "./Policy.scss";
import PolicyCombineContent from "./PolicyCombineContent";

export default function Policy() {
  const [open, setOpen] = useState(false);
  const [flag, setFlag] = useState({ key: 2, date: "2024.11.01" });
  return (
    <section className="content-area">
      <div className="content-heading">
        <h2>개인정보처리방침</h2>
        <div className="content-select" onClick={() => setOpen(!open)}>
          <p>2024.11.01</p>
          <div
            className="black-arrow"
            style={{ transform: open && "rotate(0deg)" }}
          />
          {open && (
            <ul>
              <li onClick={() => setFlag({ key: 2, date: "2024.11.01" })}>
                2024.11.01
              </li>
              <li onClick={() => setFlag({ key: 1, date: "2022.06.07" })}>
                2022.06.07
              </li>
            </ul>
          )}
        </div>
      </div>
      <PolicyCombineContent flag={flag} />
    </section>
  );
}
